import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SoftSelect from 'components/SoftSelect';
import useFetch from 'hooks/useFetch';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

const ComunaSelector = ({ selectedComuna, setSelectedComuna }) => {
    const { data, isLoading, error } = useFetch('/api/maintenance/comunas/');
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (data) {
            setOptions(data.map(({ comuna, id_comuna }) => ({
                label: comuna,
                value: id_comuna,
            })));
        }
    }, [data]);

    return (
        <SoftBox>
            <SoftTypography 
                variant="caption"
                fontWeight="bold"
                color="text"
            >
                Comuna
            </SoftTypography>
            <SoftSelect
                options={options}
                value={options.find(option => option.value === selectedComuna)}
                onChange={setSelectedComuna}
                isLoading={isLoading}
                placeholder="Seleccione una comuna"
                error={error}
            />
        </SoftBox>
    );
}

ComunaSelector.propTypes = {
    selectedComuna: PropTypes.number,
    setSelectedComuna: PropTypes.func,
};

export default ComunaSelector;